<div class="country-alert-modal modal">
    <div class="modal-header">
        <h1>{{ data.title }}</h1>
        <mat-icon class="close" mat-dialog-close>close</mat-icon>
    </div>

    <p class="description">{{ data.alert }}</p>

    <div class="buttons">
        <button mat-flat-button class="btn default" (click)="close()">
            {{ 'button.close' | translate }}
        </button>
    </div>
</div>
